export default "__VITE_ASSET__CysiYInt__"